import { GlButton, GlDrawer, GlForm, GlFormGroup, GlFormRadioGroup } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { getContentWrapperHeight } from '~/lib/utils/dom_utils';
import { s__, __ } from '~/locale';
import csrf from '~/lib/utils/csrf';
import { CATEGORY_OPTIONS } from '~/abuse_reports/components/constants';
import { DRAWER_Z_INDEX } from '~/lib/utils/constants';
export default {
    name: 'AbuseCategorySelector',
    csrf,
    components: {
        GlButton,
        GlDrawer,
        GlForm,
        GlFormGroup,
        GlFormRadioGroup
    },
    inject: {
        reportAbusePath: {
            default: ''
        }
    },
    props: {
        reportedUserId: {
            type: Number,
            required: true
        },
        reportedFromUrl: {
            type: String,
            required: false,
            default: ''
        },
        showDrawer: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'close-drawer'
    ],
    i18n: {
        title: __('Report abuse to administrator'),
        close: __('Close'),
        label: s__('ReportAbuse|Why are you reporting this user?'),
        next: __('Next')
    },
    CATEGORY_OPTIONS,
    data () {
        return {
            selected: '',
            mounted: false
        };
    },
    computed: {
        getDrawerHeaderHeight () {
            // avoid calculating this in advance because it causes layout thrashing
            // https://gitlab.com/gitlab-org/gitlab/-/issues/331172#note_1269378396
            if (!this.showDrawer) return '0';
            return getContentWrapperHeight();
        }
    },
    mounted () {
        // this is required for the component to properly animate
        // when it is shown with v-if
        this.mounted = true;
    },
    methods: {
        closeDrawer () {
            this.$emit('close-drawer');
        }
    },
    DRAWER_Z_INDEX
};
